// File: /src/utils/auth.js

export class AuthError extends Error {
	constructor(message) {
		super(message);
		this.name = 'AuthError';
	}
}

// Função para validar o token JWT
export const isTokenValid = (token) => {
	if (!token) return false;

	try {
		const payload = JSON.parse(atob(token.split('.')[1]));
		const expirationTime = payload.exp * 1000; // Converter para milissegundos
		return Date.now() < expirationTime;
	} catch (error) {
		return false;
	}
};

// Função para limpar o estado de login
export const handleLogout = () => {
	console.warn('🚨 Token expirado. Executando logout...');
	localStorage.removeItem('authToken');
	localStorage.removeItem('user');

	// Notifica o contexto e outras abas da aplicação
	window.dispatchEvent(new Event('auth:logout'));
};
